import { combineReducers } from 'redux';
import login from './loginReduecer';
import otpVerify from './otpVerifyReducer';
import homeData from './homeReducer';
import currentAffairs from './currentAffairsReducer';
import AdsInfo from './adsInfoReducer';
import testSeriesListInfo from './testSeriesListReducer';
import checkoutTestCreation from './paymentForCreateTestReducer';
import testSeriesTestListInfo from './testSeriesTestListReducer';
import singleTestInfo from './getSingleTestInfoReducer';
import testAnalysis from './testAnalysisReducer';
import questionReport from './questionReportReducer';
import testTermsAndConditions from './testTermsAndConditionReducer';
import testInfo from './startTestReducer';
import allTestsInfo from './getAllTestReducer';
import submitTest from './submitTestReducer';
import registration from './registrationReducer';
import userNameVerify from './userNameVerifyReducer';
import verifyOTPForRegistration from './registrationVerifyOtpReducer';
import allExams from './getExamsReducer';
import coursesInfo from './getCoursesReducer';
import lessonPlanner from './getlessonPlannerReducer';
import courseMaterial from './getCourseMaterialReducer';
import librarySubjects from './getLibrarySubjectsReducers';
import libraryTopicsBySubject from './getLibraryTopicsBySubjectIdReducers';
import libraryContent from './getLibraryContentReducer';
import getHtmlContentInfo from "./getHtmlContentReducer";
import aboutUs from './aboutScreenReducer';
import appTestAndTermsConditions from './appTermsAndConditionsReducer';
import disclaimer from './disclaimerReducer';
import privacyAndPolicy from './privacyAndPolicyReducer';
import changePhoneNumber from './changePhoneNumberReducer';
import verifyChangeNumber from './verifyChangePhoneNumberReducer';
import updateProfile from './updateProfileReducer';
import getUpdateProfile from './getUpdateProfileReducer';
import uploadProfilePic from './uploadProfulePicReducer';
import logOut from './logoutReducer';
import currentAffairsWithPagination from './getCurrentAffairsWiithPaginationReducer';
import JwPlayerSourceInfo from './getJwPlayerSourceFileReducers';








const rootReducer = combineReducers({
    login,
    otpVerify,
    homeData,
    currentAffairs,
    AdsInfo,
    testSeriesListInfo,
    checkoutTestCreation,
    testSeriesTestListInfo,
    singleTestInfo,
    testAnalysis,
    questionReport,
    testTermsAndConditions,
    testInfo,
    allTestsInfo,
    submitTest,
    registration,
    userNameVerify,
    verifyOTPForRegistration,
    allExams,
    coursesInfo,
    lessonPlanner,
    courseMaterial,
    librarySubjects,
    libraryTopicsBySubject,
    libraryContent,
    getHtmlContentInfo,   
    aboutUs,
    appTestAndTermsConditions,
    disclaimer,
    privacyAndPolicy,
    changePhoneNumber,
    verifyChangeNumber,
    updateProfile,
    getUpdateProfile,
    uploadProfilePic,
    logOut,
    currentAffairsWithPagination,
    JwPlayerSourceInfo
});

export default rootReducer;
